import { apiSlice } from "@/services/api-slice";
import { VoucherReponse, VouchersReponse, CreateVoucher, SettingsVouchers } from "./vouchers.interface";
import { APIResponse } from "@/types/custom-http";

export const vouchersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Obtener todos las Comprobantes de Mercadería
    getVouchers: builder.query<APIResponse<VouchersReponse>, { stock_scope?: "SHARED" | "PRIVATE" } | void>({
      query: (params) => ({
        url: "auth/warehouse/vouchers",
        params: params?.stock_scope ? { stock_scope: params.stock_scope } : undefined,
      }),
      providesTags: ["Vouchers"],
    }),

    // Obtener todos las Comprobantes de Mercadería con exposición Completa
    getVouchersComplete: builder.query<APIResponse<VouchersReponse>, { stock_scope?: "SHARED" | "PRIVATE" } | void>({
      query: (params) => ({
        url: "auth/warehouse/vouchers/complete",
        params: params?.stock_scope ? { stock_scope: params.stock_scope } : undefined,
      }),
      providesTags: ["Vouchers"],
    }),

    // Obtener Configuraciones de Comprobantes de Mercadería
    getSettingsVouchers: builder.query<APIResponse<SettingsVouchers[]>, void>({
      query: () => ({
        url: "auth/warehouse/vouchers/settings",
      }),
      providesTags: ["Vouchers"],
    }),

    // Obtener una Comprobante de Mercadería por ID
    getVoucherById: builder.query<APIResponse<VoucherReponse>, number>({
      query: (id) => ({ url: `auth/warehouse/vouchers/${id}` }),
      providesTags: (_result, _error, id) => [{ type: "Vouchers", id }],
    }),

    // Crear un nuevo Comprobante de Mercadería
    createVoucher: builder.mutation<APIResponse<VoucherReponse>, CreateVoucher>({
      query: (user) => ({
        url: "auth/warehouse/vouchers",
        method: "POST",
        body: user,
      }),
      invalidatesTags: ["Vouchers"],
    }),
  }),
});

export const {
  useGetVouchersQuery,
  useLazyGetVouchersQuery,
  useGetSettingsVouchersQuery,
  useGetVouchersCompleteQuery,
  useGetVoucherByIdQuery,
  useLazyGetVoucherByIdQuery,
  useCreateVoucherMutation,
} = vouchersApi;
